<template>
  <div>
    <b-card no-body class="mb-0">
      <div class="m-2">
        <b-row>
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>Mostrar</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Pesquisar pela descrição..."
              />
              <b-button variant="primary" v-b-modal.modal-add-parametro @click="resetFormData">
                <div class="d-flex" style="gap: 5px">
                  <feather-icon icon="PlusIcon" />
                  <span>Parâmetro</span>
                </div>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refParametrosListTable"
        class="position-relative"
        :items="fetchParametro"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro encontrado"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(uuid)="data">
          <small class="text-muted font-monospace">{{ data.item.uuid }}</small>
        </template>

        <template #cell(actions)="data">
          <div class="d-flex" style="gap: 6px">
            <b-button
              variant="gradient-primary"
              class="btn-icon"
              size="sm"
              @click="openEditModal(data.item)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button
              variant="gradient-danger"
              class="btn-icon"
              size="sm"
              @click="openDeleteModal(data.item)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">
              Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros
            </span>
          </b-col>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalParametros"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text><feather-icon icon="ChevronLeftIcon" size="18" /></template>
              <template #next-text><feather-icon icon="ChevronRightIcon" size="18" /></template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <ModalAdd
      idModal="modal-add-parametro"
      titleModal="Criar Parâmetro"
      labelBtnOk="Adicionar"
      v-model="dataParametro"
      @ok="handleCreate($event)"
      @hidden="resetFormData"
    />

    <ModalAtt
      idModal="modal-att-parametro"
      titleModal="Editar Parâmetro"
      labelBtnOk="Salvar"
      v-model="dataParametro"
      @ok="handleUpdate($event)"
      @cancel="resetFormData"
    />

    <modal-confirmation
      v-model="isDeleteModal"
      id-modal="modal-delete-parametro"
      title="Deletar Parâmetro"
      btn-cancel-label="Cancelar"
      btn-ok-label="Sim, deletar"
      @ok="handleRemover(deletedItem.id)"
      @cancel="resetFormData"
    >
      <template #message>
        <p>Tem certeza que deseja deletar o parâmetro <strong>{{ deletedItem.parametro_descricao }}</strong>?</p>
      </template>
    </modal-confirmation>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import {
  BButton, BCard, BCol, BRow, BTable, BFormInput, BPagination,
  VBToggle, VBModal, VBTooltip,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import ModalAdd from './ModalAdd.vue';
import ModalAtt from './ModalAtt.vue';
import useList from './useList';

export default {
  components: {
    ModalAdd,
    ModalAtt,
    ModalConfirmation,
    BButton, BCard, BCol, BRow, BTable, BFormInput, BPagination,
    vSelect,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      isDeleteModal: false,
      deletedItem: { id: null, parametro_descricao: '' },
    };
  },
  methods: {
    openDeleteModal(item) {
      this.deletedItem = item;
      this.isDeleteModal = true;
    },
    openEditModal(item) {
      this.dataParametro = { ...item };
      this.$bvModal.show('modal-att-parametro');
    },
    resetFormData() {
      this.deletedItem = { id: null, parametro_descricao: '' };
      this.dataParametro = { uuid: '', parametro_descricao: '', parametro_valor: '' };
      this.isDeleteModal = false;
    },
    async handleCreate(data) {
      await this.create(data);
      this.$toast({
        component: ToastificationContent,
        props: { title: 'Sucesso', text: 'Parâmetro criado com sucesso', icon: 'CheckIcon', variant: 'success' },
      });
    },
    async handleUpdate(data) {
      await this.Updated(data);
      this.$toast({
        component: ToastificationContent,
        props: { title: 'Sucesso', text: 'Parâmetro atualizado com sucesso', icon: 'CheckIcon', variant: 'success' },
      });
    },
    async handleRemover(id) {
      await this.removerData(id);
      this.$toast({
        component: ToastificationContent,
        props: { title: 'Sucesso', text: 'Parâmetro deletado com sucesso', icon: 'CheckIcon', variant: 'success' },
      });
      this.isDeleteModal = false;
    },
  },
  setup() {
    const dataParametro = ref({ uuid: '', parametro_descricao: '', parametro_valor: '' });

    const {
      perPage, currentPage, totalParametros, dataMeta, perPageOptions,
      searchQuery, sortBy, isSortDirDesc, tableColumns,
      refParametrosListTable, fetchParametro,
      create, Updated, removerData,
    } = useList();

    return {
      dataParametro,
      perPage, currentPage, totalParametros, dataMeta, perPageOptions,
      searchQuery, sortBy, isSortDirDesc, tableColumns,
      refParametrosListTable, fetchParametro,
      create, Updated, removerData,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector { width: 90px; }
.font-monospace { font-family: monospace; font-size: 0.78rem; }
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
